import { ReactNode } from "react";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/ui/components/ui/button";
import { useAppNavigation } from "@/state/legacy_module_api";

interface PageHeaderProps {
  title?: string;
  showBack?: boolean;
  rightAction?: ReactNode;
  leftAction?: ReactNode;
}

export function PageHeader({
  title,
  showBack = false,
  rightAction,
  leftAction,
}: PageHeaderProps) {
  const { back } = useAppNavigation();

  return (
    <header data-name="page-header" className="sticky top-0 z-50 flex items-center justify-between h-14 px-4 border-b bg-background">
      <div className="flex items-center gap-2 min-w-[80px]">
        {showBack && (
          <Button data-name="back-button" variant="ghost" size="icon" onClick={back}>
            <ChevronLeft className="h-5 w-5" />
          </Button>
        )}
        {leftAction}
      </div>

      <h1 data-name="page-title" className="text-lg font-semibold truncate">{title}</h1>

      <div data-name="header-actions" className="flex items-center gap-2 min-w-[80px] justify-end">
        {rightAction}
      </div>
    </header>
  );
}
